var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-icon',_vm._g(_vm._b({staticClass:"material-icons",attrs:{"color":_vm.color,"class-prefix":"material-icons"}},'van-icon',_vm.$attrs,false),_vm.$listeners),[(!_vm.name)?_vm._t("default"):_vm._e(),_vm._v(_vm._s(_vm.name))],2)}
var staticRenderFns = []

export { render, staticRenderFns }